import React, { ReactNode } from 'react';
import AntdAlert from 'antd/lib/alert';

/**
 * {@docCategory Alert}
 */
export interface AlertProps {
   /**
    * The title for the alert (required).
    */
   title: ReactNode;

   /**
    * The content of the alert.
    */
   content?: ReactNode;

   /**
    * Action for the alert.
    */
   action?: ReactNode;

   /**
    * Whether to show as banner.
    * @defaultvalue false
    */
   banner?: boolean;

   /**
    * Whether Alert can be closed.
    * @defaultvalue false
    */
   closable?: boolean;

   /**
    * Close text to show.
    */
   closeText?: ReactNode;

   /**
    * Custom icon. The showIcon prop will be set to true if this is set.
    */
   icon?: ReactNode;

   /**
    * Whether to show icon.
    * @defaultvalue false when banner = false, true when banner = true
    */
   showIcon?: boolean;

   /**
    * Type of Alert styles, options: error, info, success, warning.
    */
   type?: 'error' | 'info' | 'success' | 'warning';

   /**
    * Callback when Alert is closed.
    */
   onClose?: () => void;
}

export const Alert = (props: AlertProps) => {
   return (
      <AntdAlert
         banner={props.banner}
         action={props.action}
         closable={props.closable}
         closeText={props.closeText}
         message={props.title}
         description={props.content}
         icon={props.icon}
         showIcon={props.icon !== undefined ? true : props.showIcon}
         type={props.type}
         onClose={props.onClose}
      />
   );
};
